import { OmakasePlanModal } from './OmakasePlanModal';

export default OmakasePlanModal;
